import type { StatCard } from "../../../services/api";
import { AREA_TOTAL_LABEL } from "../../../utils/areaFormatting";

export function getAreaNotAdequateWarning(energyLabel: "solar" | "eólico"): string {
  return `Área selecionada não é adequada para gerar valores de potencial ${energyLabel}. Selecione outra região ou uma área maior.`;
}

export function hasZeroStats(cards: StatCard[]): boolean {
  const relevant = cards.filter(({ label }) => label !== AREA_TOTAL_LABEL);
  if (relevant.length === 0) return false;
  return relevant.some(({ value }) => {
    // Premissa: valores vêm em pt-BR (ponto = milhar, vírgula = decimal).
    // Alguns cards de área desenhada (Potencial Instalável/Energia Anual)
    // vêm do backend com ponto decimal (formato US) — ver
    // docs/patch-area-cards-format-mismatch-bug.md. Isso não quebra esta
    // checagem porque remover o ponto nunca transforma um valor realmente
    // não-zero numa sequência só de zeros; só corrompe a magnitude, que não
    // importa aqui (só o zero/não-zero importa).
    const num = parseFloat(value.replace(/\./g, "").replace(",", "."));
    return !isNaN(num) && num === 0;
  });
}
